import request from "../config/network/requestFinalCoursewareApiService";

// 获取场景类别集合
export function queryThemeType() {
  return request({
    url: "theme/type/get",
    method: "get",
  });
}
// 新增场景类别
export function addThemeType(data) {
  return request({
    url: "theme/type/store",
    method: "post",
    data,
  });
}
// 场景类别移动
export function moveThemeType({ id, type_id }) {
  return request({
    url: `theme/move_theme_type/${id}/${type_id}`,
    method: "put",
  });
}
// 场景复制
export function copyTheme({ id }) {
  return request({
    url: `theme/copy/${id}`,
    method: "post",
  });
}

